function charge(form) {
  var form = $('#donate-form'),
      errbox=$('#donate-form-errmsg',form),
      finbox=$('.donate-form-success',form),
      btn  = $('.donate-button',form)
  $('input[name="m2"]').val($.now())
  //
  errbox.hide()
  finbox.hide()
  btn.hide()
  $.jpost('https://o.xddx.us/stripe/cc', form, function(x){
    if(x.err!==undefined && x.err==0) {
      $('input[type="text"]',form).val('')
      finbox.show()
    } else {
      var i,msg = (!x.err_msg ? '' : x.err_msg)
      if(x.items) {
        for(i=0; i<x.items.length; i++) msg += '<br />'+x.items[i]
      }
      btn.show()
      errbox.html(msg).show()
    }
  });
  return new Promise((resolve, reject) => {
    resolve('Charged')
  })
}

export default {
  charge
}



// WEBPACK FOOTER //
// ./src/donateApi.js